<div class="time-container">
  <div class="time">
    {{toTime()}},
  </div>
  <div>
    {{toDate()}}
  </div>
</div>

<div class="outer-container">

  <div class="info-container">
    <div class="date-info-container">

      <div class="parent-date">
        <button class="nav-btn" type="button" (click)="offsetDecrease()">

          <svg width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 0-.708 0L4 8.293l6.646 6.647a.5.5 0 0 0 .708-.708L5.707 8l5.647-5.646a.5.5 0 0 0 0-.708z" />
          </svg>
        </button>

        <input class="date-input" [max]="today.toFormat('yyyy-MM-dd')" (change)="onDateChange($event)" type="date"
          value="{{displayDate.toFormat('yyyy-MM-dd')}}">
        <!-- <input class="date-input" type="text" value="{{ today.toFormat('d-MMMM-yyyy')}}"> -->

        <button class="nav-btn" type="button" (click)="offsetIncrease()" [disabled]="disableNext()">
          <svg width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0L12 8.293l-6.646 6.647a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>

      </div>

    </div>

    <!-- Three tab -->
    <div class="tab-container">

      <div class="tab-1" [ngClass]="getBidRoundStatusClass(bidRoundStatus.Open)">
        <div class="tab tab1">Bid Open</div>
        <span class="black">Till {{bidStartAllocation }}</span>
      </div>

      <div class="tab-2" [ngClass]="getBidRoundStatusClass(bidRoundStatus.Closed)">
        <div class="tab tab2">Accept / Reject</div>
        <span class="black">{{bidStartAllocation }} - {{bidEndAllocation }}</span>
      </div>

      <div class="tab-3" [ngClass]="getBidRoundStatusClass(bidRoundStatus.Completed)">
        <div class="tab tab3">Reconciled</div>
        <span class="black">After {{bidEndAllocation }}</span>
      </div>

    </div>

    <div class="bid-category-container">

      <div class="bid-category">Bid Category</div>
      <select name="bid-category" class="form-control" (change)="onBidCategoryChange($event)">
        <option *ngFor="let category of bidCategories" [value]="category" [selected]="category===defaultBidCategory">
          {{category}}
        </option>
      </select>

    </div>

  </div>

  <div class="bid-info-container">
    <div class="bid-info" (click)="goToReport(reportFilterOptions.Buyers)">
      <app-circle [progress]="buyerCount" [total]="buyerCount + sellerCount"
        [circleBackColor]="'rgba(255, 200, 1, 0.2)'" [circleText]="'Buyers'" [count]="buyerCount"
        [circleColor]="'#FFC801'"></app-circle>
    </div>
    <div class="bid-info" (click)="goToReport(reportFilterOptions.Sellers)">
      <app-circle [progress]="sellerCount" [total]="buyerCount + sellerCount"
        [circleBackColor]="'rgba(53, 124, 189, 0.15)'" [circleText]="'Sellers'" [count]="sellerCount"
        [circleColor]="'#357CBD'"></app-circle>
    </div>
    <div>

      <!-- strike price -->
      <div class="outer-circle">
        <div class="inner-circle">
          <div class="circle-text">
            <div class="text-1">Strike Price</div>
            <div class="text-2">{{(strikePrice !== null && strikePrice !== "0.00") ? strikePrice : "Not Available"}}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="bid-info" (click)="goToReport(reportFilterOptions.Accepted)">
      <app-circle [progress]="acceptedBidsCount" [total]="acceptedBidsCount + rejectedBidsCount"
        [circleBackColor]="'rgba(86, 183, 119, 0.15)'" [circleText]="'Accepted'" [count]="acceptedBidsCount"
        [circleColor]="'#56B777'"></app-circle>
    </div>

    <div class="bid-info" (click)="goToReport(reportFilterOptions.Rejected)">
      <app-circle [progress]="rejectedBidsCount" [total]="acceptedBidsCount + rejectedBidsCount"
        [circleBackColor]="'rgba(238, 138, 47, 0.15)'" [circleText]="'Rejected'" [count]="rejectedBidsCount"
        [circleColor]="'#EE8A2F'"></app-circle>
    </div>
  </div>

  <div class="outer-strike">
    <div class="strike-price-container">
      <div>
        <div class="label1 text1">
          Volume Traded </div>

        <div class="rect-cont rect1">
          <div [style.width]="calculateBarPercentageSingle(totalVolumeTraded, 80)" class="part part1">
            <p>{{stringOrNA(totalVolumeTraded)}}</p>
          </div>
        </div>
      </div>


      <div class="label">
        <div class="label1 text1">
          Total kwh Traded </div>

        <div class="rect-cont rect2">
          <div [style.width]="calculateBarPercentage(totalEnergyTraded, untradedEnergyVolume)" class="part part2">
            <p>{{stringOrNA(totalEnergyTraded)}}</p>
          </div>
        </div>
      </div>

      <div class="label">
        <div class="label1 text2">
          Average Price </div>

        <div class="rect-cont rect3">
          <div [style.width]="calculateBarPercentageAveragePrice()" class="part part3">
            <p>{{(averagePrice === '0.00' ? 'N/A' : averagePrice)}}</p>
          </div>
        </div>
      </div>

      <div class="label">
        <div class="label1 text2">
          Untraded kWh </div>

        <div class="rect-cont rect4">
          <div [style.width]="calculateBarPercentage(untradedEnergyVolume, totalEnergyTraded)" class="part part4">
            <p>{{stringOrNA(untradedEnergyVolume)}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
